export enum EntityPaymentTypes {
    none = 0,
    card = 1,
    country = 2,
    gift = 3,
    print = 4,
    bundle = 5,
    book = 6,
    calendar = 7,
    product_card = 8,
    product = 10,
    print_card = 11,
    participation_card = 14
}

// у гифтов свои типы при оплате
export enum GiftEntityPaymentTypes {
    card = 0,
    country = 1,
    print = 2,
    project = 3,
    calendar = 4,
    product = 5
}

export type CurrencyTypeType = 0 | 1


export enum PaymentCallbackStatus {
    done="done",
    rejected="rejected"
}
export enum EntityPaymentTypes {
    none = 0,
    card = 1,
    country = 2,
    gift = 3,
    print = 4,
    bundle = 5,
    book = 6,
    calendar = 7,
    product_card = 8,
    product = 10,
    print_card = 11,
    participation_card = 14
}

// у гифтов свои типы при оплате
export enum GiftEntityPaymentTypes {
    card = 0,
    country = 1,
    print = 2,
    project = 3,
    calendar = 4,
    product = 5
}

export type CurrencyTypeType = 0 | 1


export enum PaymentCallbackStatus {
    done="done",
    rejected="rejected"
}
